function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilled99X99Px = function SvgFilled99X99Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 99 99"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 78,
    x: 51.17,
    y: -6,
    fill: "#E2001A",
    rx: 15,
    style: {
      mixBlendMode: "multiply"
    },
    transform: "rotate(46.625 51.17 -6)"
  }));
};
export default SvgFilled99X99Px;